<template>
  <div :class="{ footer: true, big: big }">
    <div :class="{ mainCenter: true }">
      <ul>
        <li class="left fl">
          <div>{{$lang('footer.lianxi')}}</div>
          <div class="f-csp" @click="gouser()">{{$lang('footer.tiaokuan')}}</div>
          <div class="f-csp" @click="gopolicy()">{{$lang('footer.yinsi')}}</div>
        </li>
        <li class="right fr">
          <div class="f-csp" @click="goCreate()">{{$lang('header.create')}}</div>
          <div class="f-csp" @click="gofuli()">{{$lang('header.benefits')}}</div>
          <div class="f-csp" @click="godownload()">{{$lang('footer.xiazai')}}</div>
        </li>
      </ul>
<!--      <div class="emailInfo" v-if="this.$route.path == '/welfare'&&$i18n.locale == 'en'">-->
<!--        kayla@meetnovel.com | megan@meetnovel.com</div>-->
<!--      <div class="emailInfo" v-if="this.$route.path == '/welfare'&&$i18n.locale == 'id'">-->
<!--        sara20210318@gmail.com</div>-->
      <div class="emailInfo" v-if="this.$route.path != '/welfare'">hwkefu@gmail.com</div>
      <div style="clear: both"><img src="@/assets/logo.png" alt="logo" class="logo"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { scrollTo } from '@/utils/scroll-to'
export default {
  props: {
    big: Boolean
  },
  data() {
    return {
      fixed: false
    };
  },
  methods:{
    goCreate () {
      this.$router.push('/Create/0')
    },
    gofuli () {
      if (this.$route.path == '/welfare') {
        scrollTo(0, 800)
      } else {
        this.$router.push('/welfare')
      }
    },
    godownload () {
      if (this.$route.path == '/welfare') {
        this.$router.push('/')
      } else {
        scrollTo(0, 800)
      }
    },
    gopolicy () {
      this.$router.push('/privacy')
    },
    gouser () {
      this.$router.push('/userAgree')
    }
  }
};
</script>

<style lang="scss" scoped>
.footer{
  background:#1F1F28;
  display: inline-block;
  width:100%;
  .mainCenter{
    width: 1055px;
    margin: auto;
    margin-top: 48px;
    font-size: 16px;
    color: #CACACA;
    line-height: 40px;
    .emailInfo{
      clear:both;
      padding-top: 60px;
      color: #9B9D9E
    }
    .logo{
      width: 262px;
      height: 48px;
      margin-bottom: 54px;
      margin-top: 28px;
    }

  }
}


/*&.big
    background #1D1E1F

    .mainCenter
        /*idth 1200px
        dilay table
        margin-bottom 123px
        color #9B9D9E
        font-size 16px
        font-family "Arial Rounded MT Bold"
        .left
          div
            color #CACACA
            line-height 40px
        .right
          margin-right 162px
          div
            color #CACACA
            line-height 40px

    .emailInfo
        clear both
        padding-top 60px
&.fixed
    position fixed
    bottom 0
    left 0
.mainCenter
    width 1016px
    margin 0 auto
    color #666666
    font-size 14px
    li
        &:last-child
            margin-bottom 0
        a
            font-size 14px
            cursor pointer
    a
        color #666666
        font-size 18px
    span
        font-size 18px
        display inline-block
        margin 0 5px*/
</style>
